exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stage-tasks-list .smooth-dnd-container {\n  min-height: 500px;\n}\n", ""]);

// exports
